var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Arrow")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Portal-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Cronometrer",
    transform: "translate(-107.000000, -45.000000)",
    fill: "#D5D5D5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.821457,46.6785603 C114.821457,47.2287842 114.611077,47.762825 114.222684,48.1512183 L103.687515,58.6863871 C103.299122,59.0585974 102.765081,59.2851602 102.214857,59.2851602 C101.664633,59.2851602 101.146775,59.0585974 100.758382,58.6863871 L99.544653,57.472658 C99.1562597,57.0842647 98.929697,56.5502239 98.929697,56 C98.929697,55.4497761 99.1562597,54.9157353 99.544653,54.527342 L104.286288,49.7857069 L92.8934174,49.7857069 C91.7282375,49.7857069 91,48.8147236 91,47.7142758 L91,45.6428448 C91,44.5423971 91.7282375,43.5714138 92.8934174,43.5714138 L104.286288,43.5714138 L99.544653,38.8135956 C99.1562597,38.4413853 98.929697,37.9073445 98.929697,37.3571206 C98.929697,36.8068968 99.1562597,36.2728559 99.544653,35.9006457 L100.758382,34.6869166 C101.146775,34.2985232 101.664633,34.0719605 102.214857,34.0719605 C102.765081,34.0719605 103.299122,34.2985232 103.687515,34.6869166 L114.222684,45.2220854 C114.611077,45.5942956 114.821457,46.1283364 114.821457,46.6785603 Z",
    id: "Arrow"
  }))))));
};

export default __webpack_public_path__ + "static/media/icon-arrow-right.0e4dec40.svg";
export { SvgIconArrowRight as ReactComponent };